import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { trackNavigationHeaderClick } from '../../../../../shared';
import type { MenuQuickLink } from '../../../../../types';
import { AccountAction } from './account-action';
import './quick-links.scss';
type QuickLinksProps = {
  links: MenuQuickLink[];
  onLinkSelect: () => void;
};
export function QuickLinks(t0) {
  const $ = _c(12);
  const {
    links,
    onLinkSelect
  } = t0;
  let t1;
  if ($[0] !== onLinkSelect) {
    t1 = function handleLinkClick(label, url) {
      trackNavigationHeaderClick({
        selection: label.toLowerCase(),
        linkUrl: url
      });
      onLinkSelect();
    };
    $[0] = onLinkSelect;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLinkClick = t1;
  let t2;
  if ($[2] !== handleLinkClick || $[3] !== links) {
    let t3;
    if ($[5] !== handleLinkClick) {
      t3 = t4 => {
        const {
          label: label_0,
          openInNewTab,
          url: url_0
        } = t4;
        return <li key={url_0}><Link href={url_0} className="mobile-menu-quick-links__link" rel={openInNewTab ? "noopener noreferrer" : undefined} target={openInNewTab ? "_blank" : undefined} onClick={() => handleLinkClick(label_0, url_0)}>{label_0}</Link></li>;
      };
      $[5] = handleLinkClick;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = links.map(t3);
    $[2] = handleLinkClick;
    $[3] = links;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== onLinkSelect) {
    t3 = <li><AccountAction onLinkSelect={onLinkSelect} /></li>;
    $[7] = onLinkSelect;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <nav aria-label="Quick links"><ul className="mobile-menu-quick-links">{t2}{t3}</ul></nav>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}